import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormGroup, FormControl, TextField, Button } from '@mui/material';
import createAxiosInstance from '../../../../api';
import { useAlert } from '../../../../components/Notification';
import { useForm } from 'react-hook-form';

// type FormName = 'roleName' | 'permission';

const CreateRole = () => {
  const axiosInstance = createAxiosInstance();
  const navigate = useNavigate();
  const { name, id } = useParams();
  const showAlert = useAlert();
  // const [formData, setFormData] = useState({ roleName: name ? name : '' });
  const [roleName, setRoleName] = useState(name || '');
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string>
  >({});

  // const handleFormData = (formName: FormName, formValue: string[] | string) => {
  //   let updatedValue: string[] | string;

  //   if (typeof formValue === 'string') {
  //     if (formValue.length < 1) {
  //       setValidationErrors({
  //         ...validationErrors,
  //         roleName: 'Role Name is required',
  //       });
  //     } else {
  //       setValidationErrors({ ...validationErrors, roleName: '' });
  //     }
  //     const form_Data = { ...validationErrors };
  //     delete form_Data.roleName;
  //     setValidationErrors(form_Data);
  //     updatedValue = formValue;
  //   } else {
  //     if (formValue.length < 1) {
  //       setValidationErrors({
  //         ...validationErrors,
  //         permission: 'Assign Permission is required',
  //       });
  //     } else {
  //       setValidationErrors({ ...validationErrors, permission: '' });
  //     }
  //     const form_Data = { ...validationErrors };
  //     delete form_Data.permission;
  //     setValidationErrors(form_Data);
  //     updatedValue = formValue;
  //   }
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     [formName]: updatedValue,
  //   }));
  // };

  const validateForm = () => {
    const errors: Record<string, string> = {};

    if (roleName.trim() === '') {
      errors.roleName = 'Role Name is required';
    }

    const regex = /^[a-zA-Z0-9_ -]+$/;

    if (roleName.length > 0) {
      if (!regex.test(roleName)) {
        errors.roleName = 'Special character not allowed';
      }
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const submitedData = (data?: any) => {
    const isValid = validateForm();

    if (isValid) {
      const url = id ? '/updateRole' : '/createRole';
      const payload = id
        ? { roleName: roleName, roleID: id }
        : { roleName: roleName };
      axiosInstance
        .post(url, payload)
        .then(() => {
          showAlert('Role Create Successful', 'success');
          navigate('/iam/role');
        })
        .catch(() => {
          showAlert('Failed Role Create', 'warning');
        });
    }
  };

  const handleKeyPress = (event: {
    key: string;
    preventDefault: () => void;
  }) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      submitedData();
    }
  };

  return (
    <div className="form-role_management">
      <FormControl className="w-100">
        <div className="form-item w-100">
          <div className="form-item-label">
            <h6>
              <b>Role Name</b>
            </h6>
            <p className="m-0">
              Provide a name which will used later to identify this role
            </p>
          </div>
          <div className="form-item-input">
            <FormGroup>
              <TextField
                value={roleName}
                id="rolename"
                variant="outlined"
                fullWidth
                onChange={(e) => {
                  setValidationErrors({});
                  setRoleName(e.target.value);
                  // handleFormData('roleName', e.target.value as string)
                }}
                onKeyPress={handleKeyPress}
                error={validationErrors.roleName ? true : false}
              />
              {validationErrors.roleName && (
                <span className="text-danger">{validationErrors.roleName}</span>
              )}
            </FormGroup>
          </div>
        </div>
      </FormControl>
      <hr />
      <div className="submit-btn d-flex justify-content-end">
        <Button
          color="primary"
          onClick={() => {
            submitedData();
          }}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default CreateRole;
